import DefaultLayout from '~/Layouts/DefaultLayout/DefaultLayout';

function Home() {
    return <DefaultLayout></DefaultLayout>;
}

export default Home;
